import digitalData from 'digital-data';
import { BUTTON_SUBMISSION, BIA_MY_ACCOUNT, BIA_FILTER_BY, BIA_SEARCH_BUTTON, BIA_CATEGORY, BIA_SUBCATEGORY1, BIA_SUBCATEGORY2_PAGINATION, BIA_PAGE_NAME_PAGINATION, BIA_PAGE_TYPE, BIA_CARD_VIEW, BIA_TABLE_VIEW } from '../constants';

export const buyItAgain = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.timeFilter', ({ output }) => {
    const { timeFilter = '' } = output;

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: {
        settings: BIA_FILTER_BY + `${timeFilter}`
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.searchButton', ({ output }) => {
    const { searchFilter = '', searchTerm = '' } = output;

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: {
        settings: BIA_SEARCH_BUTTON,
        searchTerm,
        searchBy: searchFilter
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.pagePagination', () => {

    const DDOEvent = {
      category: {
        primaryCategory: BIA_CATEGORY,
        subCategory1: BIA_SUBCATEGORY1,
        subCategory2: BIA_SUBCATEGORY2_PAGINATION
      },
      pageInfo: {
        pageName: BIA_PAGE_NAME_PAGINATION,
        pageType: BIA_PAGE_TYPE,
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.pageView', ({ output }) => {
    const { view = 'Grid' } = output;
    const settings = view === 'Grid' ? BIA_CARD_VIEW : BIA_TABLE_VIEW;

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: {
        settings
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};